import 'systemjs';

import { ENVIRONMENTS, getEnvFromHostname } from 'pages/utils/getEnvFromHostname';

System.addImportMap({
  imports: {
    '@lightspeed/invoicing':
      'https://ls-mfe-assets-cdn.lightspeed.app/invoicing/lightspeed-invoicing.CSugTCPC.js',
    '@lightspeed/invoicing-css':
      'https://ls-mfe-assets-cdn.lightspeed.app/invoicing/lightspeed-invoicing.BkO4Ct64.css',
  },
});
const hasImportMapDevtools = () => {
  return localStorage.getItem('overrides-ui') === 'true';
};

if (getEnvFromHostname() === ENVIRONMENTS.DEVELOPMENT && hasImportMapDevtools()) {
  System.addImportMap({
    imports: {
      '@lightspeed/invoicing': 'http://localhost:4173/lightspeed-invoicing.js',
      '@lightspeed/invoicing-css': 'http://localhost:4173/lightspeed-invoicing.css',
    },
  });
}

const SystemJS = System;

export { SystemJS };
